import React from 'react'
import image1 from "../img/csm_job13-182-chim-00362-id-417469-jpeg_b5f8fb8ff0.jpg"

const Slide1 = () => {
    return (
        <div className="">
            <div className="container container1">
                <div class="head"></div>
                <div className="header1">
                    <h2>Wir Alten bitten Sie:</h2>
                </div>
                <div className="header2">
                    <h2>
                        GEBEN SIE IHRE STIMME<br></br>
                        <span>FÜR DIE ZUKUNFT DER JUNGEN!</span>
                    </h2>
                </div>
                <div className="image image1">
                    <img src={image1} alt=""></img>
                </div>
                <div className="header">
                    <h2>
                        Wir sind schon älter und<br></br>
                        <span>engagieren uns bei den Grünen</span>
                    </h2>
                </div>
                <div className="text">
                    Seit Jahrzehnten warnen die
                    <span> Klimaforschung, die Umweltbewegung
                    und auch wir Grüne vor den
                    katastrophalen Auswirkungen des
                    Klimawandels.</span> Sie haben extreme Hitze,
                    monströse Waldbrände, das Schmelzen der Gletscher und  gewaltige Hochwasserschäden vorausgesagt.
                    Ihre Forderung war, den Ausstoß klimaschädlicher Gase massiv zu beschränken.
                    Es wurde zu wenig getan, jetzt kommen der Klimawandel und die Folgen immer schneller,
                    immer heftiger auf uns zu:   weltweit, in Europa, auch bei uns in Deutschland.
                </div>
                <div class="Footer"></div>
            </div>
        </div>
    )
}

export default Slide1;